<template>
    <div>
        <psi-page-title :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></psi-page-title>
        <!-- Content always starts with a v-card  -->
        <v-card class="mt-4" height="700">
            <v-card-text>
                <h4 class="mb-2">Search Applications</h4>
                <v-divider></v-divider>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
export default {
    name: "application-colors",
    data() {
        return {
            page: {
                title: "Search Applications",
                icon: "mdi-account-search",
            },
            breadcrumbs: [
                {
                    text: "Applications",
                    disabled: false,
                    to: "#",
                },
                {
                    text: "Search",
                    disabled: true,
                },
            ],
        };
    },
    mounted() {},
};
</script>

<style scoped>
</style>